import React, { ChangeEvent, useRef } from "react";
import { Box, Typography, Button } from "@mui/material";
import upload from "../../../assets/images/CloudUpload.svg";
import { showToast } from "../toastNotification";

interface LogoUploadProps {
  label?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  fileName?: string;
}

const LogoUpload: React.FC<LogoUploadProps> = ({
  label,
  onChange,
  required,
  fileName,
}) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (file) {
      const allowedTypes = [
        "image/png",
        "image/jpeg",
        "image/jpg",
        "image/gif",
        "image/svg+xml",
        "application/pdf",
      ];

      if (!allowedTypes.includes(file.type)) {
        showToast(
          "Only images (PNG, JPEG, JPG, GIF, SVG) and documents (PDF) are allowed.",
          "error"
        );

        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        return;
      }

      onChange(event);

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } else {
      showToast("Please select a file.", "error");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "0px",
        mb: "8px",
      }}
    >
      {label && (
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: "medium", fontSize: "12px", display: "flex" }}
        >
          {label}{" "}
          {required && (
            <span style={{ color: "red", lineHeight: "1.5" }}>*</span>
          )}
        </Typography>
      )}
      <Button
        component="label"
        variant="outlined"
        sx={{
          width: "90px",
          height: "85px",
          border: "1px solid #808080",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",

          cursor: "pointer",
          borderRadius: "0px",
          backgroundColor: "#393939",
          mt: 0,
        }}
      >
        <img src={upload} alt="Upload Icon" width={24} height={24} />

        <Typography sx={{ fontSize: "10px", color: "#CCCCCC", mt: 1 }}>
          Upload
        </Typography>
        <input
          ref={fileInputRef}
          type="file"
          hidden
          onChange={handleFileChange}
          accept=".png,.jpeg,.jpg,.gif,.svg,.pdf,"
        />
      </Button>
      {fileName && (
        <Typography sx={{ fontSize: "12px", color: "#CCCCCC", mt: 0 }}>
          {fileName}
        </Typography>
      )}
    </Box>
  );
};

export default LogoUpload;
